/*
This file contains shared constants (that can be used by multiple modules within app)
 */

export const MIME_TYPE = {
  TEXT: 'text/plain',
  HTML: 'text/html'
}

// A copy of this has been used in flock app as well:
// flock-app/server/src/notifications/awardMessages.js
export const PALETTE = [
  '#5997E6',
  '#B9A643',
  '#64BDEF',
  '#6490EF',
  '#18C5DD',
  '#00C4FF',
  '#897AE7',
  '#F2C10E',
  '#CB7AE7',
  '#F9A640',
  '#61648B',
  '#E27A85',
  '#DAAC07',
  '#6AC7AC',
  '#A064B6',
  '#FF7D56',
  '#3D99EF',
  '#436083'
]

export const CHART_PALETTE = [
  '#76D7B8',
  '#80B7ED',
  '#007ef2',
  '#F6EE5C',
  '#F09F49',
  '#E96466',
  '#9FAAAA'
]

export const xsrfCookieName = 'csrftoken'
export const xsrfHeaderName = 'X-CSRFToken'

export const SEVERITY_MAP = {
  low: {
    label: 'Low',
    id: 'low',
    severity: 1
  },
  medium: {
    label: 'Mid',
    id: 'medium',
    severity: 2
  },
  high: {
    label: 'High',
    id: 'high',
    severity: 3
  }
}

export const SEVERITY_BADGE_MAP = {
  low: 'badge-low',
  high: 'badge-high',
  medium: 'badge-medium'
}

export const THEME = {
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  DARK: 'dark'
}

export const VARIANT_MAP = {
  'status-on-track': THEME.SUCCESS,
  'status-behind': THEME.WARNING,
  'status-at-risk': THEME.DANGER,
  'outcome-completed': THEME.SUCCESS,
  'outcome-missed': THEME.DANGER,
  'outcome-partial': THEME.WARNING,
  'outcome-dropped': THEME.DARK
}

export const OUTCOMES = [
  {
    id: 'completed',
    label: 'Completed',
    variant: VARIANT_MAP['outcome-completed']
  },
  {
    id: 'partial',
    label: 'Partial',
    variant: VARIANT_MAP['outcome-partial']
  },
  {
    id: 'missed',
    label: 'Missed',
    variant: VARIANT_MAP['outcome-missed']
  },
  {
    id: 'dropped',
    label: 'Dropped',
    variant: VARIANT_MAP['outcome-dropped']
  }
]

export const DEBOUNCE_TIME = 300

export const LoadingState = {
  LOADED: 0,
  LOADING: 1,
  ERRORED: 2,
  WAITING: 3,
  STREAMING: 4
}

export const APP_NAME = 'North'

export const CONTEXT_TYPE = {
  TEAM: 'team',
  PROJECT: 'project'
}

export const DEFAULT_LOCALE = 'en-US'

export const ORG_SWITCH_QUERY_NAME = 'orgSwitched'
export const COLORS = [
  'b8e7df',
  'f8dfde',
  'f7debb',
  'e0f2fc',
  'ddd9fe',
  'f5e3d7',
  'e8e8e8',
  'cbd0d8',
  'e3f1f3',
  'f5e4fa',
  'e1f0e7',
  'fcf3cf'
]
export const NO_COLOR = 'ffffff'

export const VIEW_TYPE = {
  READ: 'READ',
  EDIT: 'EDIT'
}
